import getLocalString from "constants/Localization";
import { useRestoreEmployeeMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useRestoreEmployee() {
  const [mutation, { loading, data, error }] = useRestoreEmployeeMutation({
    refetchQueries: ["getEmployees", "customGetEmployees"],
  });

  const [restoreEmployee, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "restoreEmployee",
    },
    {
      successMessage: getLocalString("organization.restore-employee-success"),
      failureMessage: getLocalString("organization.restore-employee-failure"),
    }
  );

  return [restoreEmployee, context] as const;
}
